var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer py-3"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-4"},[_vm._v(_vm._s(new Date().getFullYear())+" © Namirembe Diocese Young Sacco.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }